import $ from 'jquery';

// Makes a toggle element swap for an input element and focus that input,
// then hides the input when you're done interacting with it

class InputReveal {
  constructor(element) {
    this.container = $(element);
    this.toggle = this.container.find('.js-InputReveal-toggle');
    this.input = this.container.find('.js-InputReveal-input');
    this.toggle.on('click.jax.inputReveal', () => this.reveal());
    this.input.on('blur.jax.inputReveal', () => this.hide());
  }

  reveal() {
    this.container.addClass('is-revealed');
    this.input.focus();
  }

  hide() {
    this.container.removeClass('is-revealed');
  }

  static _jQueryInterface(config) {
    return this.each(function () {
      const $this = $(this);
      let data = $this.data('jax.inputReveal');

      if (!data) {
        data = new InputReveal(this);
        $(this).data('jax.inputReveal', data);
      }
    });
  }
}

$.fn.inputReveal = InputReveal._jQueryInterface;
$.fn.inputReveal.Constructor = InputReveal;

export default InputReveal;
